<template>
    <b-modal
        id="check-tagged-product-modal"
        ref="CheckTaggedProduct"
        hide-header
        hide-footer
        size="lg"
    >
        <b-row>
            <b-col sm="1">
                <img src="@/assets/images/warning.svg" alt="warning icon">
            </b-col>
            <b-col sm="11">
                <p>The product is attached to brand/s. To permanently delete, go to Locations tab first and un-tag the product.</p>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="7"></b-col>
            <b-col sm="5">
                <div class="action-buttons">
                    <span style="color:#D6D6D6; margin-right: 1rem;" @click="closeModal">Cancel</span>
                    <span style="color:#FF8828; margin-right: 1rem;" @click="goToLocations()">Go to Locations</span>  
                </div>
            </b-col>
        </b-row>
        <!-- <div slot="modal-footer">
            <b-button variant="ghost" v-bind:disabled="loading" class="btn-cancel" style="margin-right: .25rem;" @click="closeModal">
                Cancel
            </b-button>
            <b-button variant="primary" v-bind:disabled="loading" style="margin-left: .25rem;" @click="deleteProduct">
                <template v-if="loading">
                    Deleting...
                </template>
                <template v-else>
                    Yes, Delete
                </template>
            </b-button>
            <span class="modal-helper-message d-block mt-4">Caution: This cannot be undone.</span>
        </div> -->
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ConfirmDelete",
    props: ["status", "name"],
    computed: {
        ...mapState("estoreInventories", ["loading", "errors", "modal"])
    },
    methods: {
        closeModal: function() {
            this.$store.commit("estoreInventories/setModal", {
                type: "check_tagged_product",
                status: false,
                uuid: null,
                name: ""
            });
        },

        goToLocations: function() {
            this.$store.commit("estoreInventories/setModal", {
                type: "check_tagged_product",
                status: false,
                uuid: null,
                name: ""
            });
            this.$router.push({ path: "locations" });
        },

        deleteProduct: async function() {
            let uuid = this.modal.delete_product.uuid;
            await this.$store.dispatch("dstoreInventories/deleteProduct", uuid)
                .then(() => {
                    if (this.errors == null) {
                        this.$store.commit("estoreInventories/setModal", {
                            type: "delete_product",
                            status: false,
                            uuid: null,
                            name: ""
                        });
                        this.$store.dispatch("estoreInventories/getProducts", {
                            page: 1,
                            payload: {
                                filters: {
                                    paired_key: "all",
                                    keyword: "",
                                    column: "all"
                                }
                            }
                        });
                    }
                });
        }
    },
    watch: {
        status: function(status) {
            if (status == true) {
                this.$refs.CheckTaggedProduct.show();
            } else {
                this.$refs.CheckTaggedProduct.hide();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.action-buttons {
    cursor: pointer;
    a {
        text-decoration: none;
    }
}
</style>
